export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9630.ed8833f6.jpg";